import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import useOidcService from '../../hooks/auths/useOidcService';

export default function LoginCallback() {
  const { handleSigninCallback } = useOidcService();
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    handleSigninCallback()
      .then(user => {
        const searchParams = new URLSearchParams(location.search);
        const state = searchParams.get('state');
        
        if (state) {
          // State format is: "stateId;redirectUrl"
          const redirectUrl = state.split(';')[1];
          if (redirectUrl) {
            navigate(decodeURIComponent(redirectUrl));
            return;
          }
        }
        
        navigate(user.url_state || '/');
      })
      .catch((err) => {
        console.log('Error on oidc login callback', err);
      });
  }, [handleSigninCallback, navigate, location.search]);

  return <></>;
}
